<template>
  <div>
    <v-layout
      row
      wrap
      class="ma-0"
    >
      <div
        v-for="(item,index) in images"
        :key="item.urlPath"
        :style="{ width: imageWidth + 'px' }"
        class="imageItem mr-1 mb-1"
      >
        <v-card
          flat
          tile
        >
          <v-img
            :src="item.urlPath | upyun('!/fh/150')"
            aspect-ratio="1"
            class="grey lighten-2"
          />
          <v-layout
            class="btns"
            row
            wrap
            justify-center
            @click="viewImage(index)"
          >
            <v-icon>visibility</v-icon>
          </v-layout>
        </v-card>
      </div>
    </v-layout>
  </div>
</template>

<script>
import eventBus, { eventType } from '@g/utils/eventBus'
export default {
  props: {
    images: Array,
    imageWidth: {
      type: Number,
      default: 100
    }
  },
  data () {
    return {
    }
  },
  methods: {
    viewImage (index) {
      eventBus.$emit(eventType.ViewImages, {
        index,
        images: this.images.map(item => item.urlPath)
      })
    }
  }
}
</script>

<style lang="postcss" scoped>
.imageItem {
  overflow: hidden;
  .btns {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.8);
    opacity: 0;
    transition: all 0.5s;
    cursor: pointer;
    i {
      color: #fff;
    }
  }
  &:hover {
    .btns {
      opacity: 1;
    }
  }
}
</style>
